import React, { useEffect } from "react";
import CreateMarathonQuestion from "./CreateMarathonQuestion";

import { useDispatch, useSelector } from "react-redux";
import TestsRequests from "services/tests";
import GridContainer from "@jumbo/components/GridContainer";
import { Grid } from "@material-ui/core";

const AllMarathonQuestions = ({ id, category }) => {
  const { marathonQuestionsById } = useSelector(({ tests }) => tests);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(TestsRequests.getMarathonQuestionsById(id,category));
  }, [id, category]);

  return (
    <GridContainer>
      <Grid item xs={12}>
        <CreateMarathonQuestion eventId={id} />
        {marathonQuestionsById &&
          marathonQuestionsById.map((item) => (
            <CreateMarathonQuestion
              question={item}
              key={item._id}
              eventId={id}
            />
          ))}
      </Grid>
    </GridContainer>
  );
};

export default AllMarathonQuestions;
